
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/internships",
      function () {
        return require("private-next-pages/internships.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/internships"])
      });
    }
  